/**
 * Created by MinhQuan on 4/25/2016.
 */

angular.module('taric.duty.calculate.commodity', ['common.directive.gonoTree', 'taric.model.cd', 'taric.auth.model', 'common.model.language', 'common.filter.commoditycode'])
    .controller('CalculateDutyCommodityCtrl', function ($translatePartialLoader, CalculateDutyModel, LanguageModel, SearchByNomenclatureModel, GoodsNomenclatureTreeModel, CommonHelper, CONSTANTS, $filter, $rootScope, AuthorizeModel) {
        $translatePartialLoader.addPart('taric/duties/calculate');
        var calculateDutyCommodityCtrl = this;
        calculateDutyCommodityCtrl.init = function () {
            calculateDutyCommodityCtrl.model = CalculateDutyModel;
            calculateDutyCommodityCtrl.dateFormat = CONSTANTS.dateFormat;
            calculateDutyCommodityCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            calculateDutyCommodityCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
            calculateDutyCommodityCtrl.simulationDate = calculateDutyCommodityCtrl.calculationInput.simulationDate;
            calculateDutyCommodityCtrl.commodityCode = calculateDutyCommodityCtrl.calculationInput.commodityCode;
            calculateDutyCommodityCtrl.updateExpandAll();
            LanguageModel.getPreferredUILanguages().then(function (result) {
                calculateDutyCommodityCtrl.languages = result.items;
            });
            calculateDutyCommodityCtrl.search();

            calculateDutyCommodityCtrl.model = CalculateDutyModel;
            calculateDutyCommodityCtrl.model.loggedIn = AuthorizeModel.loggedIn;
            calculateDutyCommodityCtrl.releaseManagement = CONSTANTS.releaseManagement;
            if (CONSTANTS.releaseManagement && AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer()) {
                calculateDutyCommodityCtrl.model.includeUnreleased = true;
                calculateDutyCommodityCtrl.showIncludeUnreleased = true;
            } else {
                calculateDutyCommodityCtrl.model.includeUnreleased = false;
                calculateDutyCommodityCtrl.showIncludeUnreleased = false;
            }
        };

        calculateDutyCommodityCtrl.search = function () {
            calculateDutyCommodityCtrl.errorCode = CommonHelper.validateCommodityCode(calculateDutyCommodityCtrl.calculationInput.commodityCode, calculateDutyCommodityCtrl.calculationInput.tradeDirection);
            if (calculateDutyCommodityCtrl.errorCode) {
                return;
            }
            if (!CONSTANTS.dateRestrictionEnabled) {
                calculateDutyCommodityCtrl.errorCode = CommonHelper.validateSimulationDate(calculateDutyCommodityCtrl.calculationInput.simulationDate);
                if (calculateDutyCommodityCtrl.errorCode) {
                    calculateDutyCommodityCtrl.errorParams = {param0: CONSTANTS.pastDate};
                    return;
                }
            }

            calculateDutyCommodityCtrl.searching = true;
            calculateDutyCommodityCtrl.treeDataList = null;

            SearchByNomenclatureModel.searchGoodsNomenclature(calculateDutyCommodityCtrl.calculationInput.commodityCode,
                calculateDutyCommodityCtrl.calculationInput.tradeDirection,
                calculateDutyCommodityCtrl.calculationInput.simulationDate,
                calculateDutyCommodityCtrl.calculationInput.language).then(function (result) {
                calculateDutyCommodityCtrl.treeDataList = GoodsNomenclatureTreeModel.buildGonoTree(result.items, calculateDutyCommodityCtrl.calculationInput.commodityCode, calculateDutyCommodityCtrl.calculationInput.expandAll);
                calculateDutyCommodityCtrl.searching = false;
                calculateDutyCommodityCtrl.checkForCommodityCodeExistence();

                if (calculateDutyCommodityCtrl.treeDataList){
                    calculateDutyCommodityCtrl.treeDataList.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(calculateDutyCommodityCtrl.calculationInput.simulationDate);
                    if (calculateDutyCommodityCtrl.treeDataList.infoCode &&
                        "i8n.common.pastDate" === calculateDutyCommodityCtrl.treeDataList.infoCode) {
                        calculateDutyCommodityCtrl.treeDataList.infoParams = CONSTANTS.pastDate;
                    }
                }
            }, function (error) {
                calculateDutyCommodityCtrl.errorCode = error.data.code;
                calculateDutyCommodityCtrl.errorParams = error.data.params;
                calculateDutyCommodityCtrl.searching = false;
                calculateDutyCommodityCtrl.remapErrorParameters();
            });
        };

        calculateDutyCommodityCtrl.resetError = function () {
            calculateDutyCommodityCtrl.handleError(null);
        };

        calculateDutyCommodityCtrl.handleError = function (error) {
            if (!error) {
                calculateDutyCommodityCtrl.errorCode = null;
                calculateDutyCommodityCtrl.errorParams = null;
            } else {
                calculateDutyCommodityCtrl.errorCode = error.errorCode;
                calculateDutyCommodityCtrl.errorParams = error.errorParams;
            }
        };

        calculateDutyCommodityCtrl.selectCommodityCode = function (commodityCode) {
            calculateDutyCommodityCtrl.resetError();
            commodityCode = $filter('commodityCode')(commodityCode);
            calculateDutyCommodityCtrl.model.setCommodityCode(commodityCode);
            calculateDutyCommodityCtrl.commodityCode = commodityCode;
        };

        calculateDutyCommodityCtrl.openDatePicker = function ($event) {
            calculateDutyCommodityCtrl.isDatePickerOpen = true;
        };

        calculateDutyCommodityCtrl.setSimulationDate = function (dateString) {
            calculateDutyCommodityCtrl.resetError();
            calculateDutyCommodityCtrl.simulationDate = CommonHelper.formatDate(calculateDutyCommodityCtrl.simulationDate, dateString);
            calculateDutyCommodityCtrl.model.setSimulationDate(calculateDutyCommodityCtrl.simulationDate);
        };

        calculateDutyCommodityCtrl.setCommodityCode = function () {
            calculateDutyCommodityCtrl.selectCommodityCode(calculateDutyCommodityCtrl.commodityCode);
        };

        calculateDutyCommodityCtrl.validateCommodityCode = function () {
            calculateDutyCommodityCtrl.errorCode = CommonHelper.validateDeclarableCommodityCode(calculateDutyCommodityCtrl.calculationInput.commodityCode, calculateDutyCommodityCtrl.calculationInput.tradeDirection);
            return calculateDutyCommodityCtrl.errorCode === null;
        };

        calculateDutyCommodityCtrl.validateSimulationDate = function () {
            if (!CONSTANTS.dateRestrictionEnabled) {
                calculateDutyCommodityCtrl.errorCode = CommonHelper.validateSimulationDate(calculateDutyCommodityCtrl.calculationInput.simulationDate);
                if(calculateDutyCommodityCtrl.errorCode) {
                    calculateDutyCommodityCtrl.errorParams = {param0: CONSTANTS.pastDate};
                }
            }
            return calculateDutyCommodityCtrl.errorCode === null;
        };

        calculateDutyCommodityCtrl.gotoDataTab = function () {
            calculateDutyCommodityCtrl.errorCode = null;
            calculateDutyCommodityCtrl.navigatingToNextTab = true;
            CalculateDutyModel.isCommodityCodeDeclarable(calculateDutyCommodityCtrl.calculationInput.commodityCode,
                calculateDutyCommodityCtrl.calculationInput.simulationDate,
                calculateDutyCommodityCtrl.calculationInput.tradeDirection).then(function (result) {
                if (result) {
                    calculateDutyCommodityCtrl.model.goToNextTab('commodity').then(function(){
                        calculateDutyCommodityCtrl.navigatingToNextTab = false;
                    }, function (error) {
                        calculateDutyCommodityCtrl.errorCode = error.data.code;
                        calculateDutyCommodityCtrl.errorParams = error.data.params;
                        calculateDutyCommodityCtrl.navigatingToNextTab = false;
                    });
                } else {
                    calculateDutyCommodityCtrl.errorCode = "i8n.qry.cd.qryCalcDutiesBean.commodityCode.invalid";
                }

                calculateDutyCommodityCtrl.navigatingToNextTab = false;

            }, function (error) {
                calculateDutyCommodityCtrl.errorCode = error.data.code;
                calculateDutyCommodityCtrl.errorParams = error.data.params;
                calculateDutyCommodityCtrl.navigatingToNextTab = false;
            });
        };

        calculateDutyCommodityCtrl.updateExpandAll = function(){
            var commodityCode = CommonHelper.removeSpaceCharacters(calculateDutyCommodityCtrl.calculationInput.commodityCode);
            calculateDutyCommodityCtrl.shouldEnableExpandAll = commodityCode.length >= 2;
            if (!calculateDutyCommodityCtrl.shouldEnableExpandAll){
                calculateDutyCommodityCtrl.calculationInput.expandAll = false;
            }
        };

        calculateDutyCommodityCtrl.checkForCommodityCodeExistence = function(){
            if (calculateDutyCommodityCtrl.treeDataList === null || calculateDutyCommodityCtrl.treeDataList.length === 0){
                calculateDutyCommodityCtrl.errorCode = "tqf.cc.notFound";
                calculateDutyCommodityCtrl.errorParams = {param0: calculateDutyCommodityCtrl.commodityCode, param1: calculateDutyCommodityCtrl.commodityCode};
            }
        };

        calculateDutyCommodityCtrl.remapErrorParameters = function(){
            if (calculateDutyCommodityCtrl.errorCode === "tqf.cc.notFound"){
                calculateDutyCommodityCtrl.errorParams = {param0: calculateDutyCommodityCtrl.commodityCode, param1: calculateDutyCommodityCtrl.commodityCode};
            }
        };


    });




// WEBPACK FOOTER //
// ./app/taric/duties/calculate/commodity/cd.commodity.js